import React from 'react'

import { useOrganization } from '@application/Interfaces/Hooks/useOrganization/useOrganization'
import { FooterThemeModeType, HeaderThemeModeType, ThemeModeType } from '@src/Application/Types/ComponentTypes'
import { Opt } from '@src/Application/Types/Opt'

type Props = {
    mode: Opt<ThemeModeType | HeaderThemeModeType | FooterThemeModeType>
    width?: number
    height?: number
}

export const OrganizationLogo = (props: Props): React.ReactElement => {
    const { mode, width, height } = props

    const organization = useOrganization()

    const ColorLogo = organization.logos.logoColor
    const WhiteLogo = organization.logos.logoWhite

    if (!mode || mode === 'Light' || mode === 'Neutral') {
        return <ColorLogo width={width} height={height} />
    }

    return <WhiteLogo width={width} height={height} />
}
